import { Snackbar, TextField } from '@material-ui/core'
import { QRCodeSVG } from 'qrcode.react'
import React, { useCallback, useRef, useState } from 'react'
import { Config } from 'settings/config'
import * as Styled from './ChatBotInstructions.styled'
import ButtonShadow from 'components/ButtonShadow/ButtonShadow'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import LaunchIcon from '@mui/icons-material/Launch'
import openURL from 'utils/openURL'

const BOT_URL = `https://t.me/${Config.TELEGRAM_BOT_USERNAME}?startgroup=yes`

const ChatBotInstructions: React.FC = () => {
  const [copyTextResult, setCopyTextResult] = useState<string | undefined>(
    undefined,
  )
  const inputUrlRef = useRef<HTMLInputElement>(null)

  const handleCopyLink = useCallback(async () => {
    inputUrlRef.current?.select()
    const success = document.execCommand('copy')
    setCopyTextResult(success ? 'Link Copiado!' : 'Erro ao copiar link')
    inputUrlRef.current?.blur()
  }, [])

  const handleOpenLink = useCallback(async () => {
    await openURL(BOT_URL)
  }, [])

  return (
    <Styled.Container>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={!!copyTextResult}
        onClose={() => setCopyTextResult(undefined)}
        message={copyTextResult}
        autoHideDuration={3000}
      />

      <Styled.Title>
        A conta vinculada deve adicionar @{Config.TELEGRAM_BOT_USERNAME} no
        grupo como administrador.
      </Styled.Title>

      <Styled.QrCodeContainer>
        <QRCodeSVG value={BOT_URL} size={256} marginSize={4} />
      </Styled.QrCodeContainer>

      <Styled.LinkContainer>
        <TextField
          type="text"
          value={BOT_URL}
          onChange={() => {}}
          variant="outlined"
          fullWidth
          inputRef={inputUrlRef}
        />

        <Styled.LinkActions>
          <ButtonShadow
            leftIcon={<ContentCopyIcon style={{ color: 'white' }} />}
            onPress={handleCopyLink}
          />
          <ButtonShadow
            leftIcon={<LaunchIcon style={{ color: 'white' }} />}
            onPress={handleOpenLink}
          />
        </Styled.LinkActions>
      </Styled.LinkContainer>
    </Styled.Container>
  )
}

export default ChatBotInstructions
